import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http'
import { BaseService } from '@aifs-shared/common/base-service';
import { BaseResponse } from '@aifs-shared/common/base-response';
import { Observable, Subject } from 'rxjs';
import { UserService } from '@aifs-shared/user/user.service';
import { ToDoItem } from './todo-item';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ToDoService extends BaseService {
    private router = inject(Router);
    private http = inject(HttpClient);
    private userService = inject(UserService);

    constructor() { super(); }

    public getToDoForApplication(): Observable<ToDoItem[]> {
        let subject = new Subject<ToDoItem[]>();

        const applicantId = this.userService.applicantId();
        const activeApplicationId = this.userService.activeApplicationId();

        this.http
            .get<BaseResponse>(
                environment.ServiceUrl_ApplicationToDo(applicantId, activeApplicationId!)
            )
            .subscribe({
                next: (data: any) => {
                    if (data.result && data.result['toDo']) {
                        const response = data.result['toDo'];
                        subject.next(response);
                    } else {
                        subject.next([]);
                    }
                },
                error: (error: any) => {
                    subject.error(error);
                }
            });

        return subject;
    }

}
